export default __webpack_public_path__ + "396207916eff3abd7120055c1880c2fd.svg";